'use client';
import { createContext } from 'react';
import { AppConfiguration } from '../auth';

export const appConfigurationContext = createContext<AppConfiguration>({
  appName: '',
  serviceId: '',
});

export function AppConfigurationProvider({
  value,
  children,
}: {
  value: AppConfiguration;
  children: React.ReactNode;
}) {
  return (
    <appConfigurationContext.Provider value={value}>{children}</appConfigurationContext.Provider>
  );
}
